module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kigcG"))).then(() => parcelRequire('iDabs'));